module.exports = __webpack_public_path__ + "img/cww_04.3e54c4cb.jpg";